import { render } from "./collectStoreItem.vue?vue&type=template&id=afaac664"
import script from "./collectStoreItem.vue?vue&type=script&lang=js"
export * from "./collectStoreItem.vue?vue&type=script&lang=js"

import "./collectStoreItem.vue?vue&type=style&index=0&id=afaac664&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__